"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config = {
    level: process.env.LOG_LEVEL || "debug",
    prettyPrint: process.env.LOG_PRETTY === "true" || process.env.NODE_ENV === "development"
};
exports.default = config;
//# sourceMappingURL=config.js.map